import type { OverWritable } from '../../@types/settings';

export const loadingButton: OverWritable = {
  MuiLoadingButton: {
    styleOverrides: {
      root: {
        '&.MuiButton-text': {
          '& .MuiLoadingButton-startIconPendingStart': {
            marginLeft: 0,
          },
          '& .MuiLoadingButton-endIconPendingEnd': {
            marginRight: 0,
          },
        },
      },
    },
  },
};
